$(document).ready(function(){

  if ( $('label.active').length ) {
    $('.blog__tooltip').text('Twoja ocena');
    // $('.blog__tooltip').show();
  }

  $("[data-rate-post] .blog__stars:not(.voted) label").unbind().bind("click",function(){
      parent = $(this).closest("[data-rate-post]");
      $.post("/module/postrate",{
        "post_id": $(this).closest("[data-rate-post]").attr("data-rate-post"),
        "rate": $(this).attr('data-value'),
        "_token": window.Laravel.csrfToken
      },function(response){
          // console.log('thanks for voting');
          response.rate = parseFloat(response.rate).toFixed(1);
          $("[data-rate-counter]").html(response.counter);
          $("[data-rate-value]").html(response.rate);
          $(".blog__stars:not(.voted)").find('label.active').removeClass('active');
          if(response.rate>0){
            $(".blog__stars:not(.voted)").each(function() {
              $(this).find('label').eq(4).addClass('active');
            }); // eq(4) - is first the star - because of flex-direction: reverse-row styling
          }
          if(response.rate>=2) {
            $(".blog__stars:not(.voted)").each(function() {
              $(this).find('label').eq(3).addClass('active');
            });
          }

          if(response.rate>=3) {
            $(".blog__stars:not(.voted)").each(function() {
              $(this).find('label').eq(2).addClass('active');
              $(this).find('label').eq(3).addClass('active');
            });
          }

          if(response.rate>=4) {
            $(".blog__stars:not(.voted)").each(function() {
              $(this).find('label').eq(1).addClass('active');
              $(this).find('label').eq(2).addClass('active');
              $(this).find('label').eq(3).addClass('active');
            });
          }

          if(response.rate==5) {
            $(".blog__stars").each(function() {
              $(this).find('label').eq(0).addClass('active');
              $(this).find('label').eq(1).addClass('active');
              $(this).find('label').eq(2).addClass('active');
              $(this).find('label').eq(3).addClass('active');
            });
          }


            $('.blog__tooltip').fadeIn('slow', function(){
              // if ( $('.blog__stars.voted').length ) {
                $('.blog__tooltip').delay(3000).fadeOut();
              // }
            });
      });
  });
});
